import { combineReducers } from 'redux'
import generalReducer from '../thunks/generlAppState/reducers'
import { loginReducer } from '../thunks/login/reduers'
import meReducer from '../thunks/me/reducers'
import { testReducer } from '../thunks/test/reducers'

const appReducer = combineReducers({
  generalState: generalReducer,
  login: loginReducer,
  me: meReducer,
  test: testReducer
})

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    localStorage.removeItem('authToken')
    return appReducer(undefined, action)
  }
  return appReducer(state, action)
}

export default rootReducer
